import React from "react";
import { Wrapper, Status } from "@googlemaps/react-wrapper";

import MapComponent from './MapComponent';

const MapWrapper = (props) => {

    //console.log(props.lat, props.long)
    //console.log(props.lat, props.lat.length)
    
    return  props.lat && props.lat  > 0 ? (
        // <Wrapper apiKey={"AIzaSyDiQImz2VYZlRubgd2YBQAwCoEGTCipBkw"} render={render}>
                <MapComponent lat={props.lat} long={props.long} />
        // </Wrapper>
    ) : null;
}

export default MapWrapper;